import * as Sentry from '@sentry/nextjs'
import { useRouter } from 'next/router'
import { useCallback, useState } from 'react'

import { toaster } from '@/components/Toaster'
import { useReplayReportRequest } from '@/feature/reports/api/useReplayReportRequest'
import { ReportFormat } from '@/feature/reports/types/Report'

import { routePaths } from '@/lib/core/constants/routes'

export const useReplayMapMessage = (assetId: number) => {
  const { trigger: requestReplay } = useReplayReportRequest()
  const router = useRouter()

  const [reportOpen, setReportOpen] = useState(false)

  const requestReport = useCallback(
    ({ from, to, format }: { from: Date; to: Date | undefined; format: ReportFormat }) => {
      setReportOpen(false)
      requestReplay({ fromDate: from, toDate: to!, assetId, outputFormat: format })
        .then(() => {
          toaster({ type: 'success', message: 'Replay events export started' })
          router.push(routePaths.reportDownloads)
        })
        .catch((error) => {
          Sentry.captureException(error, {
            extra: { assetId, fromDate: from, toDate: to, outputFormat: format },
            tags: { feature: 'replay', api: 'replay-report-request' },
          })
          toaster({ type: 'error', message: 'Failed to export replay events' })
        })
    },
    [assetId, requestReplay, router],
  )

  return { reportOpen, setReportOpen, requestReport }
}
